import { Add, AssessmentOutlined } from '@mui/icons-material'
import { Box, useTheme } from '@mui/material'
import { Context, memo } from 'react'
import { useTranslation } from 'react-i18next'
import FormSchemasDialog from 'src/components/overallReport/FormSchemasDialog'
import { permissionValue } from 'src/enums/permissionValue'
import { ILocality } from 'src/generated-types'
import { useMainComponentReportFormInitialValues } from 'src/screens/localities/utils/localityReportFormDefaults'
import { formSchemaReportTypes } from 'src/generated-types/form-schema'
import { IMainComponent } from 'src/generated-types/main-component'
import { useDialogCtx } from 'src/hooks/context-hooks'
import { MUIThemeColors } from 'src/mui-theme'
import { getThemeColor } from 'src/utils'
import EquipmentSectionLayout from './EquipmentSectionLayout'
import ReportInEquipment from './ReportsInEquipment'

export const REPORT_MAX_VISIBLE_ROWS = 10

interface Props {
  context: Context<any> | null | undefined
  customerId: EntityId
  localityId: EntityId | undefined
  mainComponentId: any
  mainComponent: IMainComponent | undefined
  locality: ILocality | undefined
  isReadOnly?: boolean
  documentCount: number
  onReportCountChange: (length: number) => void
  height: number
}

const ReportSection = memo((props: Props) => {
  const {
    context,
    mainComponent,
    mainComponentId,
    customerId,
    localityId,
    locality,
    isReadOnly,
    documentCount,
    onReportCountChange,
  } = props
  const { showDialog } = useDialogCtx()
  const reportFormInitialValues = useMainComponentReportFormInitialValues(mainComponent, locality)
  const { t } = useTranslation(['main-component'])
  const theme = useTheme()

  const onAddReport = async () => {
    showDialog(
      FormSchemasDialog,
      {
        componentProps: {
          customerId: customerId,
          localityId: localityId as any,
          property: {
            mainComponentId: mainComponentId,
            type: formSchemaReportTypes.MainComponent,
          },
          formInitialValues: reportFormInitialValues,
        },
        opts: {
          maxWidth: 'md',
          fullWidth: true,
        },
      },
      undefined,
      true,
    )
  }

  return (
    <Box height="100%">
      <EquipmentSectionLayout
        title={t('reports', { ns: 'common' })}
        icon={<AssessmentOutlined sx={{ fontSize: '18px', color: getThemeColor(theme, MUIThemeColors.primaryMain) }} />}
        buttonText={t('new-form', { ns: 'overall-reports' })}
        buttonIcon={<Add />}
        sx={{ paddingBottom: '0px' }}
        onButtonClick={onAddReport}
        context={context}
        permissions={[
          permissionValue.Locality.MainComponent.Document.Write,
          permissionValue.ClientAdminPermission,
          permissionValue.ServiceStation.Write,
          permissionValue.ClientAdminPortal.Equipment_Portal,
        ]}
        content={
          <ReportInEquipment
            {...props}
            height="100%"
            autoHeight={false}
            maxVisibleRowCount={REPORT_MAX_VISIBLE_ROWS}
            minimalEmptyStatus={true}
            setDataLength={onReportCountChange}
            isReadOnly={isReadOnly}
          />
        }
        isReadOnly={isReadOnly}
      />
    </Box>
  )
})

export default ReportSection
